// packages/console/src/lib/roles.ts
//
// Workspace-role predicates shared across the console. Roles ride on the
// session's active workspace (api/tenancy WorkspaceView.role).

// isAdminRole is the single source of truth for admin-surface visibility (today
// the probe bit-distribution graph): a workspace "admin" or "owner", where
// owner is a superset of admin.
export function isAdminRole(role: string | undefined): boolean {
  return role === "admin" || role === "owner";
}

// canManageUsers gates the user-management panel: owner, admin, and manager may add
// and manage users. A manager can add users but, unlike admin, cannot access preset
// settings (that stays isAdminRole). The server enforces the created_by hierarchy.
export function canManageUsers(role: string | undefined): boolean {
  return role === "owner" || role === "admin" || role === "manager";
}

// canEditPreset gates preset settings (view/edit) by OWNERSHIP, mirroring the server:
// EVE/standard (system) profiles are the workspace owner's only; a custom profile is
// its creator's (and the owner's). Everyone else gets no edit button and no editor.
// The server enforces this regardless; this hides the affordance in the console.
export function canEditPreset(
  preset: { eve?: boolean; builtin?: boolean; createdBy?: string } | null | undefined,
  role: string | undefined,
  userId: string | undefined,
): boolean {
  if (!preset) return false;
  if (role === "owner") return true;
  if (preset.eve || preset.builtin) return false; // system profiles: owner only
  return !!preset.createdBy && preset.createdBy === userId; // own custom profile
}
